import { CHANNEL_STATUS, type IVenueDocument } from '@mitter-group/contracts';

/**
 * Si el comercio ve Pedidos y Analitica. Las dos son del canal delivery: los pedidos de la
 * vitrina van por WhatsApp y no pasan por la base. Con delivery en cualquier estado que no
 * sea `active` (suspendido, rechazado, pendiente o sin canal) quedan Productos y Cuenta.
 *
 * Sin documento se muestran: el comercio recien registrado todavia no tiene `venue`, y es la
 * comanda la que le pide crear el perfil.
 */
export function showsDeliveryTabs(venue: IVenueDocument | undefined): boolean {
  return !venue || venue.channels?.delivery?.status === CHANNEL_STATUS.ACTIVE;
}
